module.exports = ".loko {\n  color: \"white\"; }\n"